import {
    Component,
    Inject,
    Input,
    PLATFORM_ID,
    Renderer2,
    SimpleChanges,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {
    UntypedFormBuilder,
    UntypedFormControl,
    Validators,
    FormsModule,
    ReactiveFormsModule,
    UntypedFormArray,
    UntypedFormGroup
} from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AuthenticationService, MakeOfferService } from '@app/_services';
import { ProductPageService } from '@app/_services/productPage.service';
import { QuotationCartService } from '@app/_services/quotation.service';
import { CartService } from '@services/cart.service';
import { CompareService } from '@services/compare.service';
import { OptionsEventService } from '@services/optionsEvent.service';
import { RootService } from '@services/root.service';
import { WishlistService } from '@services/wishlist.service';
import * as _ from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AskVendorComponent } from '../../../shared/components/ask-vendor/ask-vendor.component';

import {
    ViewportScroller,
    isPlatformBrowser,
    NgClass,
    NgStyle,
    NgFor,
    NgIf,
    KeyValuePipe,
    CurrencyPipe // Add this import
} from '@angular/common';
import { Title } from '@angular/platform-browser';
import { ChatModalComponent } from '@app/_components/live-chat/chat-modal/chat-modal.component';
import { VariantProductsModalComponent } from '@app/_components/product-tabs/components/variant-products-modal/variant-products-modal.component';
import { FormDataHelper, TranslateHelper } from '@app/_helpers';
import { ChatService } from '@app/_services/chat.service';
import { CurrencyService } from '@app/_services/currency.service';
import { SharedService } from '@app/_services/shared.service';
import { SiteService } from '@app/_services/site.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CurrencyFormatPipe } from '../../../shared/pipes/currency-format.pipe';
import { ColorTypePipe } from '../../../shared/pipes/color-type.pipe';
import { ProductGalleryComponent } from '../../../shared/components/product-gallery/product-gallery.component';
import { BlocksCalculatorComponent } from '../calculators/blocks-calculator/blocks-calculator.component';
import { IconComponent } from '../../../shared/components/icon/icon.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { MatTabsModule } from '@angular/material/tabs';
import { SocialShareButtonsComponent } from '../../share-buttons/social-share-buttons.component';
import { ProductOptionsComponent } from '../product-options/product-options.component';
import { InputNumberNewComponent } from '../../../shared/components/input-number-new/input-number-new.component';
import { FlexModule } from '@angular/flex-layout/flex';
import { ProductVariantsOptionsComponent } from '../product-variants-options/product-variants-options.component';
import { MatIconModule } from '@angular/material/icon';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { ClickDirective } from '../../../shared/directives/click.directive';
import { EventCollectorDirective } from '../../../_directives/events-collector/events.collector';
import { ProductGalleryNewComponent } from '../../../shared/components/product-gallery-new/product-gallery-new.component';
import { MatDividerModule } from '@angular/material/divider';
import { QuotationRequestService } from '@app/_services/quotation-request.service';
import { ProductOptionType } from '@app/_models';
import { BookingService } from '@app/_services/booking.service';
import { PerDayBookingComponent } from '../booking/per-day-booking/per-day-booking.component';
import { PeriodBookingComponent } from '../booking/period-booking/period-booking.component';
import { TimeSlotBookingComponent } from '../booking/time-slot-booking/time-slot-booking.component';
import * as moment from 'moment';
import { TimeSlotSelectionData } from '@app/_interfaces/time-slot-selection.interface';
import { CurrencyConvertPipe } from '@app/shared/pipes';

export type ProductLayout = 'standard' | 'sidebar' | 'columnar' | 'quickview';

@Component({
    selector: 'app-product',
    templateUrl: './product.component.html',
    styleUrls: ['./product.component.scss'],
    providers: [FormDataHelper, TranslateHelper],
    standalone: true,
    imports: [
        ProductGalleryNewComponent,
        EventCollectorDirective,
        ClickDirective,
        NgClass,
        NgIf,
        ExtendedModule,
        MatIconModule,
        MatDividerModule,
        NgStyle,
        NgFor,
        FormsModule,
        ReactiveFormsModule,
        ProductVariantsOptionsComponent,
        FlexModule,
        InputNumberNewComponent,
        ProductOptionsComponent,
        SocialShareButtonsComponent,
        MatTabsModule,
        RouterLink,
        NgScrollbarModule,
        IconComponent,
        BlocksCalculatorComponent,
        KeyValuePipe,
        TranslateModule,
        ColorTypePipe,
        CurrencyFormatPipe,
        PerDayBookingComponent,
        CurrencyPipe,
        PeriodBookingComponent,
        TimeSlotBookingComponent,
        CurrencyConvertPipe
    ]
})
export class ProductComponent {
    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private titleService: Title,
        private chatService: ChatService,
        private formDataHelper: FormDataHelper,
        private productPageService: ProductPageService,
        private cart: CartService,
        private optionsEventService: OptionsEventService,
        private quotationRequestService: QuotationRequestService,
        private wishlist: WishlistService,
        private compare: CompareService,
        public root: RootService,
        private fb: UntypedFormBuilder,
        private modalService: BsModalService,
        private authService: AuthenticationService,
        private toastr: ToastrService,
        private router: Router,
        private renderer: Renderer2,
        public translate: TranslateService,
        public translateHelper: TranslateHelper,
        private makeOfferService: MakeOfferService,
        private shareService: SharedService,
        public deviceDetector: DeviceDetectorService,
        public siteService: SiteService,
        public currency: CurrencyService,
        private scroller: ViewportScroller,
        private bookingService: BookingService
    ) {
        this.sector = this.shareService.page;

        this.modalService.onHide.subscribe(() => {
            this.renderer.removeClass(document.body, 'chat-modal');
        });

        this.modalService.onShown.subscribe(() => {
            if (document.getElementsByClassName('live-chat-popup')[0]) {
                this.renderer.addClass(
                    document.getElementsByClassName('live-chat-popup')[0]
                        .parentElement,
                    'live-chat'
                );
            }

            if (this.deviceDetector.isMobile()) {
                this.renderer.addClass(
                    document.getElementsByClassName('modal')[0],
                    'mobile'
                );
            }
        });
    }

    sector;
    @Input() layout: ProductLayout;
    @Input() product: any;
    @Input() availableShippings: any[];
    isMobile = this.deviceDetector.isMobile();
    bsModalRef: BsModalRef;
    features: any = {};
    @ViewChild('modal', { read: TemplateRef }) template: TemplateRef<any>;

    //quantity: FormControl = new FormControl(1);
    whatsapp;
    addingToCart = false;
    addingToWishlist = false;
    addingToCompare = false;
    userDetails;
    _ = _;
    formsList = [
        this.fb.group({
            length: 0,
            width: 0
        })
    ];

    isQuotable = false;
    addToCartHidden = false;

    form = this.fb.group({
        options: this.fb.array([]),
        amount: [1]
    });
    optionsLength;

    discountedPrice;
    variantSelection = new UntypedFormControl(null);
    offeredPrice = new UntypedFormControl(null);
    quoteDescription = new UntypedFormControl(null);
    canOffer = false;
    maxQuantityDiscount = {};

    // Tiles Calculator
    // tCalculator = this.fb.group({
    //     length: 0,
    //     width: 0,
    //     length1: 0,
    //     width1: 0,
    //     length2: 0,
    //     width2: 0
    // })

    // Tiles Count and Price
    tPrice = 0;
    tCount = 0;
    oldAmount = 1;

    ProductOptionType = ProductOptionType;

    public selectedOptions: {
        label: { en: string; ar: string };
        type: ProductOptionType;
        value: string | File | any;
    }[] = [];

    // Booking related properties
    isBookingProduct = false;
    bookingPrice = 0;
    isBookingSectionOpen = false;
    selectedBookingDates: string[] = [];
    selectedTimeSlots: any[] = []; // Add this property for time slots

    // Shipping availability
    canShipToUserCountry = true;
    productCountryName = '';
    userCountryName = '';

    getArea() {
        let areaList = [];
        for (let i = 0; i < this.formsList.length; i++) {
            areaList.push(
                this.formsList[i].value.length * this.formsList[i].value.width
            );
        }
        return areaList;
    }

    addArea() {
        this.formsList.push(
            this.fb.group({
                length: 0,
                width: 0
            })
        );
    }

    removeArea() {
        this.formsList.pop();
        this.getAreaPrice();
    }

    getAreaPrice() {
        this.tPrice = 0;
        this.tCount = 0;
        const totalArea = this.getArea();
        let productArea =
            this.product.measurements.dimensions?.length *
            this.product.measurements.dimensions.width;

        const checkbox = document.getElementById(
            'extra'
        ) as HTMLInputElement | null;

        if (this.product.measurements.dimensions?.type == 'cm') {
            productArea /= 100 * 100;
        }

        if (this.product.measurements.dimensions?.type == 'mm') {
            productArea /= 100 * 100 * 1000 * 1000;
        }

        let neededArea;
        for (let i = 0; i < totalArea.length; i++) {
            neededArea = Math.round(totalArea[i] / productArea);
            this.tPrice += this.product.taxedPrice * neededArea;
            this.tCount += neededArea;
        }

        if (checkbox?.checked) {
            neededArea = Math.round(neededArea * 0.1);
            this.tPrice += this.product.taxedPrice * neededArea;
            this.tCount += neededArea;
        }

        if (this.tCount) this.amount.setValue(this.tCount);
    }

    ngOnChanges(changes: SimpleChanges) {
        let variantSelection =
            (this.product.sector?.seo?.slug
                ? '/sector/' + this.product.sector?.seo?.slug + '/'
                : '/') +
            this.product.type +
            '/' +
            this.product.seo.slug;
        this.variantSelection.patchValue(variantSelection);
        this.isQuotable = false;
        this.addToCartHidden = false;
        this.addingToCart = false;

        this.checkIfQuotation();
        this.calculateDiscount();
        this.features = {};
        this.setFeatures();
        if (changes.product) {
            this.optionsLength = Object.keys(
                this.product?.options || {}
            ).length;
            /*    this.product.description.ar = this.sanitizer.bypassSecurityTrustHtml(this.product.description?.ar);
               this.product.description.en = this.sanitizer.bypassSecurityTrustHtml(this.product.description?.en); */
            if (
                isPlatformBrowser(this.platformId) &&
                changes.product.currentValue?._id !=
                    changes.product.previousValue?._id
            ) {
                this.scroller.scrollToPosition([0, 0]);
            }

            // Check shipping availability when product changes
            this.checkShippingAvailability();
        }
    }

    setOptions() {}

    setFeatures() {
        _.forEach(this.product?.features, feature => {
            let featureData = _.find(this.product.featuresData, {
                _id: feature._id
            });
            this.features[featureData?.name?.[this.translate.currentLang]] = {
                name:
                    feature?.value?.[this.translate.currentLang] ??
                    feature?.brandName
            };
            if (featureData?.filter?.type) {
                this.features[
                    featureData?.name?.[this.translate.currentLang]
                ].type = featureData.filter?.type;
            }
        });
    }

    ngOnInit(): void {
        this.canOffer = this.product?.canOffer;
        this.optionsLength = Object.keys(this.product?.options || {}).length;
        this.form.addControl(
            'suggestPrice',
            new UntypedFormControl(this.product?.suggestPriceRange?.min, [
                Validators.min(+this.product?.suggestPriceRange?.min),
                Validators.max(+this.product?.suggestPriceRange?.max)
            ])
        );

        this.form
            .get('amount')
            .patchValue(
                this.product.quantity?.min ? this.product.quantity?.min : 1
            );
        this.oldAmount = this.amount.value;

        // Check shipping availability based on country
        this.checkShippingAvailability();
        let variantSelection =
            (this.product.sector?.seo?.slug
                ? '/sector/' + this.product.sector?.seo?.slug + '/'
                : '/') +
            this.product.type +
            '/' +
            this.product.seo.slug;
        this.variantSelection.patchValue(variantSelection);

        this.optionsEventService.optionsEvent$.subscribe(response => {
            if (!response) {
                return;
            }
            this.updateValue(this.amount.value);
        });

        this.userDetails = this.authService.currentUserValue;
        this.checkIfQuotation();
        this.calculateDiscount();

        if (this.product?.companyData?.contact?.whatsapp?.e164Number) {
            // let codec = new CustomHttpUrlEncodingCodec;
            this.whatsapp = {
                // url: environment.web + this.router.url,
                number: this.product?.companyData?.contact?.whatsapp?.e164Number.substring(
                    1
                )
                // text: codec.encodeKey(`Hi, I'am interested in [ ${this.property.name.en} ] - [${this.property.code}] ${environment.web + this.router.url}`)
            };
        } else {
            this.whatsapp = null;
        }

        this.product.description = {
            en: this.product?.description?.en || '',
            ar: this.product?.description?.ar || ''
        };

        /*  this.product.description.ar = this.sanitizer.bypassSecurityTrustHtml(this.product.description?.ar);
         this.product.description.en = this.sanitizer.bypassSecurityTrustHtml(this.product.description?.en); */

        this.setFeatures();
        this.authService.currentUser.subscribe(user => {
            this.userDetails = user;
        });

        // Subscribe to country changes
        this.shareService.currentCountry$.subscribe(() => {
            this.checkShippingAvailability();
        });

        // Check if product has booking enabled
        this.isBookingProduct = this.product?.booking?.forBooking || false;
        if (this.isBookingProduct === true) {
            this.addToCartHidden = true;
        }
    }

    checkIfQuotation() {
        if (this.product?.isOnlyQuotation) {
            this.isQuotable = true;
            this.addToCartHidden = true;
            let amount =
                this.product.minQuotationAmount > 0
                    ? this.product.minQuotationAmount
                    : 1;
            this.amount.setValue(amount);
        } else if (this.product.minQuotationAmount >= 1) {
            this.isQuotable = true;
            // this.form.get('amount').patchValue(this.product.minQuotationAmount);
            this.addToCartHidden = false;
        }
    }

    get amount() {
        return this.form.get('amount') as UntypedFormControl;
    }

    addToCart(sample?): void {
        let cartItem: any = {
            productId: this.product._id,
            amount: this.amount.value,
            options: this.form.getRawValue().options
        };

        if (cartItem.options?.length > 0) {
            let optionsArray: any[] = cartItem.options;
            let optionsFiltered = [];
            let optionsObject = this.product.options;
            _.forEach(cartItem.options, option => {
                if (option.date != null) {
                    optionsFiltered.push({
                        optionId: option.optionId,
                        value: {
                            date: option.date,
                            time: option.time
                        }
                    });
                }
                if (option.valueId != null || option.value != null) {
                    optionsFiltered.push(option);
                }
            });
            cartItem.options = optionsFiltered;
        }

        let optionFiles = this.form.getRawValue().optionFiles;
        if (optionFiles) {
            cartItem['optionFiles'] = {};
            _.forEach(optionFiles, (optionFile, key) => {
                _.assign(cartItem['optionFiles'], optionFile);
            });
        }

        if (sample) {
            cartItem.isSample = true;
        }

        if (!this.addingToCart && this.product && this.amount.value > 0) {
            let fromData = this.formDataHelper.ToFormData(cartItem);
            this.cart.addItem(fromData, this.product).subscribe({
                error: data => {
                    this.toastr.error('Error adding item to cart');
                    this.addingToCart = false;
                },
                next: success => {
                    if (success.msg && success.code == 400) {
                        this.toastr.error(success.msg);
                        return;
                    }
                    if (success.cart?.warnings?.length > 0) {
                        _.forEach(success.cart?.warnings, warning => {
                            this.toastr.warning(
                                warning.description[this.translate.currentLang],
                                warning.title[this.translate.currentLang]
                            );
                        });
                    }
                    if (success.cart?.errors?.length > 0) {
                        _.forEach(success.cart.errors, error => {
                            this.toastr.error(
                                error.description[this.translate.currentLang],
                                error.title[this.translate.currentLang]
                            );
                        });

                        return;
                    }
                    this.toastr.success(
                        `Product "${
                            this.product.name[this.translate.currentLang]
                        } ${sample ? 'Sample' : ''}" added to cart!`
                    );
                    this.addingToCart = false;
                }
            });
        }
    }

    /**
     * Buy Now: add this product to cart and immediately checkout with only this item.
     * Uses same payload as addToCart but after success triggers single-item checkout.
     */
    buyNow(): void {
        if (this.addingToCart) return;
        if (!this.product || this.amount.value <= 0) return;

        this.addingToCart = true;

        // Build payload same as addToCart
        let cartItem: any = {
            productId: this.product._id,
            amount: this.amount.value,
            options: this.form.getRawValue().options
        };

        if (cartItem.options?.length > 0) {
            let optionsArray: any[] = cartItem.options;
            let optionsFiltered = [];
            _.forEach(cartItem.options, option => {
                if (option.date != null) {
                    optionsFiltered.push({
                        optionId: option.optionId,
                        value: {
                            date: option.date,
                            time: option.time
                        }
                    });
                }
                if (option.valueId != null || option.value != null) {
                    optionsFiltered.push(option);
                }
            });
            cartItem.options = optionsFiltered;
        }

        let optionFiles = this.form.getRawValue().optionFiles;
        if (optionFiles) {
            cartItem['optionFiles'] = {};
            _.forEach(optionFiles, (optionFile, key) => {
                _.assign(cartItem['optionFiles'], optionFile);
            });
        }

        // If product is sample behavior not needed here; keep same flow as addToCart

        const fromData = this.formDataHelper.ToFormData(cartItem);

        this.cart.addItem(fromData, this.product).subscribe({
            next: (success: any) => {
                this.addingToCart = false;
                if (success.msg && success.code == 400) {
                    this.toastr.error(success.msg);
                    return;
                }
                if (success.cart?.warnings?.length > 0) {
                    _.forEach(success.cart?.warnings, warning => {
                        this.toastr.warning(
                            warning.description[this.translate.currentLang],
                            warning.title[this.translate.currentLang]
                        );
                    });
                }
                if (success.cart?.errors?.length > 0) {
                    _.forEach(success.cart.errors, error => {
                        this.toastr.error(
                            error.description[this.translate.currentLang],
                            error.title[this.translate.currentLang]
                        );
                    });
                    return;
                }

                // Success: extract returned cart and find the newly added item by productId
                const returnedCart = success.cart;
                if (!returnedCart || !returnedCart._id) {
                    this.toastr.error(
                        this.translate.instant('failed_to_add_to_cart') ||
                            'Failed to add to cart'
                    );
                    return;
                }

                // find item in returned cart.items matching productId (first match)
                const addedItem = _.find(
                    returnedCart.items,
                    (it: any) =>
                        String(it.productId) === String(this.product._id)
                );
                if (!addedItem) {
                    // fallback: if item not found, still navigate to checkout for the cart
                    this.toastr.success('Added to cart');
                    const params = { cartId: returnedCart._id, itemIds: [] };
                    this.cart.userCart = {
                        cartId: returnedCart._id,
                        items: []
                    };
                    this.cart.saveCartId(params).subscribe(() => {
                        this.router.navigate(['/checkout'], {
                            state: { data: params }
                        });
                    });
                    return;
                }

                // Checkout only this item
                this.checkoutSingleItem(returnedCart._id, addedItem);
            },
            error: (err: any) => {
                this.addingToCart = false;
                console.error('BuyNow addToCart error', err);
                this.toastr.error('Failed to add to cart');
            }
        });
    }

    /**
     * Checkout only a single cart item from a cart id.
     */
    private checkoutSingleItem(cartId: string, cartItem: any) {
        const items = [cartItem.itemId];
        const params = { cartId: cartId, itemIds: items };
        // set current userCart so checkout uses this selection
        this.cart.userCart = { cartId: cartId, items: items };
        this.cart.saveCartId(params).subscribe({
            next: () => {
                this.router.navigate(['/checkout'], {
                    state: { data: params }
                });
            },
            error: () => {
                // still navigate so user can see checkout page
                this.router.navigate(['/checkout'], {
                    state: { data: params }
                });
            }
        });
    }

    public getTranslation(name): string {
        let translation;
        this.translate.get(name).subscribe(value => (translation = value));
        return translation;
    }

    addQuotation(): void {
        if (this.addingToCart) return;

        const translate = this.translateHelper.getTranslationCB;

        this.addingToCart = true;
        const form = this.form;
        const optionsForm = form.get('options') as UntypedFormArray;
        const optionFiles = form.getRawValue().optionFiles;

        if (form.value?.amount < this.product?.minQuotationAmount) {
            translate('quantity_must_be_at_least', txt =>
                this.toastr.error(`${txt} ${this.product?.minQuotationAmount}`)
            );
            this.addingToCart = false;
            return;
        }

        if (form.value?.amount <= 0) {
            translate('quantity_must_be_at_least_1', this.toastr.error);
            this.addingToCart = false;
            return;
        }

        if (!this.userDetails) {
            this.router.navigate(['/login'], {
                queryParams: {
                    returnUrl: this.router.routerState.snapshot.url
                }
            });
            this.addingToCart = false;
            return;
        }

        const missingRequired = [];
        this.selectedOptions = [];
        const optionsFormValue: any[] = optionsForm.value;

        _.each(this.product.options, (option, _id) => {
            const selectedOption = _.find(
                optionsFormValue,
                value => value?.optionId == _id
            );
            if (!selectedOption) return true;
            const optionValuePair = {
                label: option.name as { en: string; ar: string },
                type: option.type as ProductOptionType,
                value: null
            };
            switch (option.type) {
                case ProductOptionType.SelectBox:
                case ProductOptionType.RadioGroup:
                    if (
                        selectedOption?.valueId &&
                        option.values?.[selectedOption.valueId]
                    ) {
                        optionValuePair.value =
                            option.values[selectedOption.valueId];
                    } else {
                        if (option.required)
                            missingRequired.push(
                                option.name[this.translate.currentLang]
                            );
                    }
                    break;
                case ProductOptionType.ColorGroup:
                    if (
                        selectedOption?.valueId &&
                        option.values?.[selectedOption.valueId]
                    ) {
                        optionValuePair.value =
                            option.values[selectedOption.valueId];
                    } else {
                        if (option.required)
                            missingRequired.push(
                                option.name[this.translate.currentLang]
                            );
                    }
                    break;
                case ProductOptionType.Text:
                    if (selectedOption?.value) {
                        optionValuePair.value = selectedOption?.value;
                    } else {
                        if (option.required)
                            missingRequired.push(
                                option.name[this.translate.currentLang]
                            );
                    }
                    break;
                case ProductOptionType.Date:
                    if (selectedOption.date && selectedOption.time) {
                        optionValuePair.value = `${selectedOption.date} ${selectedOption.time}`;
                    } else {
                        if (option.required)
                            missingRequired.push(
                                option.name[this.translate.currentLang]
                            );
                    }
                    break;
                case ProductOptionType.File:
                    if (optionFiles.length > 0 && selectedOption.valueId) {
                        optionValuePair.value = _.find(optionFiles, fileObj =>
                            _.has(fileObj, selectedOption.valueId)
                        )?.[selectedOption.valueId];
                    } else {
                        if (option.required)
                            missingRequired.push(
                                option.name[this.translate.currentLang]
                            );
                    }

                    break;
                default:
                    optionValuePair.value = selectedOption.value;
            }
            if (optionValuePair.value == null) return true;
            this.selectedOptions.push(optionValuePair);
        });

        if (missingRequired.length > 0) {
            translate('please_fill_the_required_options', txt =>
                this.toastr.error(`${txt}: ${missingRequired.join(', ')}`)
            );
            this.addingToCart = false;
            return;
        }

        this.bsModalRef = this.modalService.show(this.template, {
            class: 'modal-lg'
        });
        this.addingToCart = false;
    }

    askVendor() {
        const initialState = {
            companyId: this.product.companyId,
            product: this.product
        };
        this.bsModalRef = this.modalService.show(AskVendorComponent, {
            initialState,
            ignoreBackdropClick: true
        });
        this.bsModalRef.content.closeBtnName = 'Close';
        this.translateHelper.getTranslationCB('close', txt => {
            this.bsModalRef.content.closeBtnName = txt;
        });
    }

    openChat(): any {
        if (!this.userDetails || !this.authService.currentUserValue) {
            return this.router.navigate(['/login'], {
                queryParams: { returnUrl: this.router.routerState.snapshot.url }
            });
        }

        // create chat
        var newChat: any = {
            companyId: this.product?.companyData?._id,
            subject: {
                type: 'product',
                title: {
                    en: this.titleService.getTitle(),
                    ar: this.titleService.getTitle()
                },
                url: window.location.href,
                ObjectId: this.product?._id
            },
            type: 'vendor',
            message: ''
        };

        this.chatService.createChat(newChat).subscribe((response: any) => {
            // console.log("CREATE CHAT::", response);

            this.bsModalRef = null;

            const initialState = {
                chatId: response.data?._id
            };

            this.bsModalRef = this.modalService.show(ChatModalComponent, {
                initialState,
                class: 'full-screen live-chat-popup',
                backdrop: false,
                ignoreBackdropClick: true
            });

            this.bsModalRef.content.closeBtnName = 'Close';

            this.renderer.addClass(document.body, 'chat-modal');
        });
    }

    showVariantsList() {
        const initialState = {
            currentProductId: this.product?._id,
            productVariants: this.product?.variants
        };
        this.bsModalRef = this.modalService.show(
            VariantProductsModalComponent,
            {
                initialState,
                class: 'modal-lg'
            }
        );
        this.bsModalRef.content.closeBtnName = 'Close';
    }

    public getColor(valid): string {
        return valid ? '#4896ec' : 'red';
    }

    calculateDiscount() {
        if (
            this.product?.discountValue?.value &&
            this.product?.discountValue.type != 'N'
        ) {
            this.discountedPrice =
                this.product?.discountValue.type == 'F'
                    ? this.product.taxedPrice ||
                      this.product.price - this.product.discountValue?.value
                    : this.product.taxedPrice ||
                      this.product.price -
                          (this.product.discountValue?.value *
                              this.product.taxedPrice || this.product.price) /
                              100;
        }
    }

    requestQuotation() {
        const options = _.cloneDeep(this.selectedOptions) as any;
        _.each(options, option => {
            option.label = option.label.en;
        });
        const reqBody = FormDataHelper.ToFormData({
            product: {
                _id: this.product._id,
                qty: this.amount.value,
                name: this.product.name,
                options: options
            },
            companyId: this.product.companyData._id,
            description: this.quoteDescription.value
        });
        this.quotationRequestService
            .singleRequest(reqBody)
            .subscribe(response => {
                if (response.code == 400) {
                    this.toastr.error('Cannot Request Quotation');
                    this.bsModalRef.hide();
                    this.addingToCart = false;
                    return;
                }

                if (response.addedNotification) {
                    this.authService.updateNotifications({
                        added: response.addedNotification
                    });
                }
                this.bsModalRef.hide();
                this.toastr.success('A request has been sent successfully');
                this.addingToCart = false;
                this.quoteDescription.reset();
            });
    }

    navigateTo(location) {
        if (location) {
            this.router.navigate([location]);
        }
        return false;
    }

    options = {};

    updateValue(quantity) {
        if (
            quantity < this.product.quantity?.min &&
            this.product.quantity?.min > 0
        ) {
            this.amount.setValue(this.product.quantity?.min);
        } else if (
            quantity > this.product.quantity?.max &&
            this.product.quantity?.max > 0
        ) {
            this.amount.setValue(this.product.quantity?.max);
        }
        quantity = this.amount.value;
        let quantityDiscount = _.filter(
            this.product.quantityDiscount,
            discount => this.amount.value >= discount.quantity
        );
        let maxQuantityDiscount = _.maxBy(quantityDiscount, 'quantity');
        let options = this.form.get('options').value;

        if (
            this.oldAmount != this.amount.value ||
            this.maxQuantityDiscount != maxQuantityDiscount ||
            options != this.options ||
            this.availableShippings?.length
        ) {
            this.oldAmount = this.amount.value;
            this.maxQuantityDiscount = maxQuantityDiscount;
            this.options = options;
            this.productPageService
                .getChangedOption({
                    slug: this.product.seo.slug,
                    options: options,
                    amount: this.amount.value
                })
                .subscribe(res => {
                    if (res.product) {
                        this.product.price = res.product.price;
                        this.product.baseTaxedPrice =
                            res.product.baseTaxedPrice;
                        this.product.quantityDiscount =
                            res.product.quantityDiscount;
                        _.forEach(this.product.options, (option, optionKey) => {
                            _.forEach(option.values, (value, valueKey) => {
                                if (value && option.type != 'D')
                                    value.price =
                                        res.product.options[optionKey]?.values[
                                            valueKey
                                        ]?.price;
                            });
                        });
                        if (!_.isEmpty(maxQuantityDiscount)) {
                            let quantityDiscount = _.filter(
                                this.product.quantityDiscount,
                                discount =>
                                    this.amount.value >= discount.quantity
                            );
                            let maxQuantityDiscount = _.maxBy(
                                quantityDiscount,
                                'quantity'
                            );
                            this.product.taxedPrice =
                                maxQuantityDiscount?.taxedPrice;
                        } else {
                            this.product.taxedPrice = res.product.taxedPrice;
                        }
                    }

                    if (res.availableShippings) {
                        this.availableShippings = res.availableShippings;
                    }
                });
        }
    }

    addToWishlist(): void {
        if (!this.addingToWishlist && this.product) {
            this.addingToWishlist = true;

            this.wishlist
                .add(this.product)
                .subscribe({ complete: () => (this.addingToWishlist = false) });
        }
    }

    addToCompare(): void {
        if (this.addingToCompare) {
            return;
        }

        this.addingToCompare = true;
        this.compare
            .add({ productId: this.product._id })
            .subscribe(response => {
                this.addingToCompare = false;
                if (response.code == 200) {
                    this.toastr.success(
                        `Product "${this.product.name?.en}" added to compare!`
                    );
                }
            });
    }

    makeOffer() {
        if (!this.userDetails) {
            this.router.navigate(['/login'], {
                queryParams: {
                    returnUrl: this.router.routerState.snapshot.url
                }
            });
            this.addingToCart = false;
            return;
        }

        let options = this.form.get('options').value;
        let offerParams = {
            offer: this.offeredPrice.value,
            options: options,
            productId: this.product._id
        };
        this.makeOfferService.makeOffer(offerParams).subscribe(response => {
            if (response.code == 200) {
                this.canOffer = false;
                this.toastr.success(response.msg);
            }
        });
    }

    toggleBookingSection(): void {
        this.isBookingSectionOpen = !this.isBookingSectionOpen;
    }

    /**
     * Gets translated expand/collapse tooltip text
     */
    getBookingToggleTooltip(): string {
        return this.isBookingSectionOpen
            ? this.translate.instant('collapse_booking_section')
            : this.translate.instant('expand_booking_section');
    }

    /**
     * Gets translated booking price badge text
     */
    // getBookingPriceBadge(): string {
    //     if (this.bookingPrice <= 0) return '';

    //     return this.translate.instant('booking_price_badge', {
    //         price: this.bookingPrice.toFixed(3) + ' BHD'
    //     });
    // }

    /**
     * Handles date selection changes from the booking component
     * @param dates Selected booking dates
     */
    onSelectedDatesChanged(dates: string[]): void {
        this.selectedBookingDates = dates;
    }

    /**
     * Handles time slot selection changes from the booking component
     * @param data Enhanced data format containing selected slots, date, and total price
     */
    onSelectedSlotsChanged(data: TimeSlotSelectionData): void {
        // Handle the enhanced data format
        this.selectedTimeSlots = data.slots;
        this.selectedBookingDates = data.selectedDate
            ? [data.selectedDate]
            : [];
        this.bookingPrice = data.totalPrice || 0;
    }

    /**
     * Gets specific summary text for time slot bookings
     */
    private getTimeSlotSummaryText(): string {
        if (this.selectedTimeSlots.length === 0) {
            return this.translate.instant('no_time_slots_selected');
        }

        const totalSlots = this.selectedTimeSlots.length;
        const selectedDate = this.selectedBookingDates[0];
        const totalPrice = this.bookingPrice;

        if (selectedDate) {
            const formattedDate = this.formatSelectedDate(selectedDate);

            if (totalSlots === 1) {
                return this.translate.instant('single_time_slot_summary', {
                    date: formattedDate,
                    price: totalPrice.toFixed(3) + ' BHD'
                });
            } else {
                return this.translate.instant('multiple_time_slots_summary', {
                    count: totalSlots,
                    date: formattedDate,
                    price: totalPrice.toFixed(3) + ' BHD'
                });
            }
        }

        // Fallback if no date available
        if (totalSlots === 1) {
            return this.translate.instant('single_time_slot_summary_no_date', {
                price: totalPrice.toFixed(3) + ' BHD'
            });
        } else {
            return this.translate.instant(
                'multiple_time_slots_summary_no_date',
                {
                    count: totalSlots,
                    price: totalPrice.toFixed(3) + ' BHD'
                }
            );
        }
    }

    /**
     * Formats the selected date for display
     */
    private formatSelectedDate(dateString: string): string {
        const currentLang = this.translate.currentLang || 'en';
        return moment(dateString)
            .locale(currentLang)
            .format('ddd, MMM D, YYYY');
    }

    /**
     * Gets comprehensive booking summary text for all booking types
     */
    getBookingSummaryText(): string {
        // Handle time slot bookings specifically
        if (this.product?.booking?.bookingType === 'timeSlots') {
            return this.getTimeSlotSummaryText();
        }

        // Handle other booking types
        if (this.selectedBookingDates.length === 0) {
            return this.translate.instant('no_booking_dates_selected');
        }

        if (this.selectedBookingDates.length === 1) {
            return this.translate.instant('booking_dates_selected', {
                count: this.selectedBookingDates.length
            });
        }

        return this.translate.instant('booking_dates_selected_plural', {
            count: this.selectedBookingDates.length
        });
    }

    onBookingPriceCalculated(price: number): void {
        const oldPrice = this.bookingPrice;
        this.bookingPrice = price;

        // Add animation class when price changes
        if (oldPrice !== price && price > 0) {
            // Trigger price update animation
            setTimeout(() => {
                const badgeElement = document.querySelector('.booking-badge');
                if (badgeElement) {
                    badgeElement.classList.add('price-updated');
                    setTimeout(() => {
                        badgeElement.classList.remove('price-updated');
                    }, 400);
                }
            }, 100);
        }
    }

    onBookingCreated(booking: any): void {
        this.toastr.success('Booking created successfully!');
        this.selectedBookingDates = [];
        this.bookingPrice = 0;

        //TODO: Add redirection to payment or something
    }

    /**
     * Handles quotation request events from booking components
     * @param quotation - The created quotation request
     */
    onQuotationRequested(quotation: any): void {
        this.toastr.success(
            this.translate.instant('quotation_request_sent_successfully')
        );
        this.selectedBookingDates = [];
        this.selectedTimeSlots = [];
        this.bookingPrice = 0;

        // Close booking section after successful quotation request
        this.isBookingSectionOpen = false;
    }

    /**
     * Handles when booking item is added to cart
     * @param event - Contains cart item data and response
     */
    onBookingAddedToCart(event: any): void {
        // Update any UI state if needed
        this.selectedBookingDates = [];
        this.bookingPrice = 0;

        // You can emit this to parent components if needed
        // or handle any additional logic like updating cart counts, etc.

        // Close booking section after successful add to cart
        this.isBookingSectionOpen = false;
    }

    /**
     * Check if product can be shipped to user's selected country
     */
    checkShippingAvailability(): void {
        const userSelectedCountry = this.shareService.selectedCountry;
        const productCountryId = this.product?.companyData?.contact?.address
            ?.countryId;

        if (!userSelectedCountry || !productCountryId) {
            this.canShipToUserCountry = true;
            return;
        }

        // Compare country IDs
        const userCountryId = userSelectedCountry._id || userSelectedCountry.id;
        const productCountryIdStr =
            typeof productCountryId === 'string'
                ? productCountryId
                : productCountryId?.toString();
        const userCountryIdStr =
            typeof userCountryId === 'string'
                ? userCountryId
                : userCountryId?.toString();

        this.canShipToUserCountry = productCountryIdStr === userCountryIdStr;

        // Store country names for display
        if (!this.canShipToUserCountry) {
            this.productCountryName =
                this.product?.companyData?.currencyMeta?.countryName?.[
                    this.translate.currentLang
                ] || '';
            this.userCountryName =
                userSelectedCountry.name?.[this.translate.currentLang] ||
                userSelectedCountry.name ||
                '';
        }
    }

    /**
     * Get the shipping restriction message
     */
    getShippingRestrictionMessage(): string {
        if (this.canShipToUserCountry) {
            return '';
        }

        return this.translate.instant('product_cannot_ship_to_country', {
            country: this.userCountryName
        });
    }
}
